<form [formGroup]="searchForm" (keydown.enter)="$event.preventDefault(); onSearch($event)">
    <div class="flex w-full my-2">
        <div class="flex-col w-2/4 m-2">
            <div class="my-2">Field Name</div>
            <div>
                <mat-form-field class="w-full">
                    <input
                        type="text"
                        placeholder="Enter at least 3 characters"
                        aria-label="Number"
                        matInput
                        formControlName="FieldName"
                        [matAutocomplete]="fieldName"
                    />

                    <mat-autocomplete
                        #fieldName="matAutocomplete"
                    >
                        <mat-option
                            *ngFor="let row of options.fields"
                            [value]="row.fieldLongName"
                        >
                            {{ row.fieldLongName }} <br/><small>({{ row.fieldShortName }})</small>
                        </mat-option>
                    </mat-autocomplete>

                    <button mat-icon-button matSuffix>
                        <mat-icon svgIcon="mat_solid:arrow_drop_down"></mat-icon>
                    </button>
                </mat-form-field>
            </div>
        </div>
        <div class="flex-col w-2/4 m-2">
            <div class="my-2">Platform Name</div>
            <div>
                <mat-form-field class="w-full">
                    <input
                        type="text"
                        placeholder="Enter at least 3 characters"
                        aria-label="Number"
                        matInput
                        formControlName="PlatformName"
                        [matAutocomplete]="platformName"
                    />
                    <mat-autocomplete
                        #platformName="matAutocomplete"
                    >
                        <mat-option
                            *ngFor="let row of options.platforms"
                            [value]="row.platformLongName"
                        >
                            {{ row.platformLongName }} <br/><small>({{ row.platformShortName }})</small>
                        </mat-option>
                    </mat-autocomplete>

                    <button mat-icon-button matSuffix>
                        <mat-icon svgIcon="mat_solid:arrow_drop_down"></mat-icon>
                    </button>
                </mat-form-field>
            </div>
        </div>

        <div class="flex-col w-2/4 m-2">
            <div class="my-2">Well Name</div>
            <div>
                <mat-form-field class="w-full">
                    <input
                        type="text"
                        placeholder="Enter at least 3 characters"
                        aria-label="Number"
                        matInput
                        formControlName="WellName"
                        [matAutocomplete]="wellName"
                    />
                    <mat-autocomplete
                        #wellName="matAutocomplete"
                    >
                        <mat-option
                            *ngFor="let row of options.wells"
                            [value]="row.wellLongName"
                        >
                            {{ row.wellLongName }} <br/><small>({{ row.wellShortName }})</small>
                        </mat-option>
                    </mat-autocomplete>

                    <button mat-icon-button matSuffix>
                        <mat-icon svgIcon="mat_solid:arrow_drop_down"></mat-icon>
                    </button>
                </mat-form-field>
            </div>
        </div>

        <div class="flex-col w-2/4 m-2">
            <div class="my-2">String Name</div>
            <div>
                <mat-form-field class="w-full">
                    <input
                        type="text"
                        placeholder="Enter at least 3 characters"
                        aria-label="Number"
                        matInput
                        formControlName="StringName"
                        [matAutocomplete]="stringName"
                    />
                    <mat-autocomplete
                        #stringName="matAutocomplete"
                    >
                        <mat-option
                            *ngFor="let row of options.wellStrings"
                            [value]="row.stringLongName"
                        >
                            {{ row.stringLongName }} <br/><small>({{ row.stringShortName }})</small>
                        </mat-option>
                    </mat-autocomplete>

                    <button mat-icon-button matSuffix>
                        <mat-icon svgIcon="mat_solid:arrow_drop_down"></mat-icon>
                    </button>
                </mat-form-field>
            </div>
        </div>
    </div>
</form>
